<!--
 * @Author: 月魂
 * @Date: 2021-06-07 11:15:55
 * @LastEditTime: 2021-07-04 17:07:54
 * @LastEditors: 月魂
 * @Description:
 * @FilePath: \nepal\src\components\menu.vue
-->
<template>
  <van-popover
    v-model="showPopover"
    trigger="click"
    :actions="this.$t('menu')"
    placement="bottom-end"
    @select="onSelect"
  >
    <template #reference>
      <van-icon name="wap-nav" size="24" class="header-icon" />
    </template>
  </van-popover>
</template>

<script>
import Vue from 'vue'
import { Popover } from 'vant'
Vue.use(Popover)

export default {
  name: 'Menu',
  data() {
    return {
      current: '',
      showPopover: false
    }
  },
  mounted() {
    this.current = window.location.hash.split('#')[1]
  },
  methods: {
    onSelect(action) {
      if (action.url === this.current) return
      this.current = action.url
      this.$router.push(action.url)
    }
  }
}
</script>

<style lang="less" scoped>
.header-icon {
  line-height: 40px;
}
</style>
